function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
        return;
    }
    const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
            callback(el);
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

waitForElement('.tl-switcher-container.desktop', function(switcher) {
    //console.log('✅ 找到元素！', switcher);

    function fixPosition() {
        // ✅ 关键：先删除所有重复的 switcher
        document.querySelectorAll('.tl-switcher-container').forEach(el => {
            if (el.parentElement === document.body) {
                el.remove(); // ✅ 删掉 body 里的旧的
            }
        });

        const isMobile = window.innerWidth < 501;

        if (isMobile) {
            //console.log('📱 移动端 → 放到 body');
            document.body.appendChild(switcher);
        } else {
           //console.log('🖥️ 桌面端 → 放回 site-header');
            const siteNavIcons = document.querySelector('.site-nav__icons');
            if (siteNavIcons) {
                siteNavIcons.insertBefore(switcher, siteNavIcons.firstChild);
            }
        }
    }

    fixPosition();
    window.addEventListener('scroll', fixPosition);
    window.addEventListener('resize', fixPosition);
});
